;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"

type Props = {
  title: string
  onClose: () => Promise<void> | void
}

export default function DialogTitleAndCloseAttendance({ title, onClose }: Props) {
  return (
    <DialogTitle id="simple-dialog-title">
      <div className={"flex justify-between items-center relative"}>
        <Typography
          variant="h2"
          sx={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          {title}
        </Typography>
        <div className={"absolute top-0 right-0"}>
          <IconButton
            className={"absolute top-[-12px] right-0 cursor-pointer"}
            onClick={() => {
              void onClose()
            }}
          >
            <CloseIcon fontSize={"large"} />
          </IconButton>
        </div>
      </div>
    </DialogTitle>
  )
}
